import { percentage } from "./convertToPercentage";

const getStoreData = () => {
  try {
    const rawAccess = localStorage.getItem("access");
    return rawAccess ? JSON.parse(rawAccess) : null;
  } catch (error) {
    console.warn("No se pudo leer la sesion local.", error);
    return null;
  }
};

const getUserData = () => getStoreData()?.user ?? {};

const getPrimarySchedule = () => {
  const schedules = getUserData().schedules;
  return Array.isArray(schedules) && schedules.length > 0 ? schedules[0] : null;
};

/**
 *
 * @returns Retorna el id de la sucursal
 */
export const idLocalStore = async () => {
  return await (getUserData().store ?? 0);
};

/**
 *
 * @returns Retorna el id del usuario que ha iniciado sesion
 */
export const idLocalUser = async () => {
  return await (getUserData().key ?? 0);
};

/**
 *
 * @returns Retorna el id del turno actual
 */
export const idLocalTurn = async () => {
  const user = getUserData();
  return await (user.currentTurn ?? getPrimarySchedule()?.turn ?? 0);
};

/**
 *
 * @returns Retorna el tipo de usuario
 */
export const localTypeUser = async () => {
  return await (getUserData().typeUser ?? "");
};

/**
 *
 * @returns Retorna el id del turno actual
 */
export const localMoney = async () => {
  const storeData = getStoreData();
  const currency = storeData?.currency ?? "";
  const prefix = storeData?.currencyPrefix ?? "";
  return {
    currency,
    prefix,
  };
};

/**
 *
 * @returns Retorna el nombre del usuario
 */
export const localUserName = async () => {
  const userName = getUserData().name ?? "";
  return userName;
};
/**
 *
 * @returns Retorna igv que esta configurado para el sistema pero en este caso el iva entero
 */
export const localIVA = async () => {
  const iva = parseInt(getStoreData()?.iva ?? 0);
  return iva;
};

/**
 *
 * @returns | Retorna el iva configurado del sistema tanto para hacer la mutiplicacion y división
 */
export const IVA_LOCAL_STORE = () => {
  const iva = percentage(getStoreData()?.iva ?? 0);

  const TO_DIVIDE = iva + 1;
  const TO_MULTIPLY = iva;

  return [TO_DIVIDE, TO_MULTIPLY];
};

/**
 *
 * @returns Retorna el  avatar del usuario
 */
export const localAvatarUser = async () => {
  const avatar = getUserData().avatar ?? "";
  return avatar;
};

/**
 *
 * @returns Retorna el total de minutos tarde ingresado
 */
export const localMinutesLate = async () => {
  const avatar = getPrimarySchedule()?.minutesLate ?? 0;
  return avatar;
};

/**
 *
 * @returns Retorna el avatar del usuario
 */
export const localDelayUser = async () => {
  const avatar = getPrimarySchedule()?.isInTime ?? true;
  return avatar;
};

/**
 *
 * @returns Retorna la hora de salida del usuario
 */
export const localExitWorkTolerance = async () => {
  const exitWorkTolerance = getPrimarySchedule()?.exitWorkTolerance ?? null;
  return exitWorkTolerance;
};

/**
 *
 * @returns Retorna si la empresa puede enviar correos
 */
export const localCanSendMail = async () => {
  const senMail = getStoreData()?.canSendMail ?? false;
  return senMail;
};
